import { WidgetType } from '@celum/portals/domain';
import { WidgetInfo } from '@celum/portals/shared';

import { AssetGalleryConfiguration, AssetGalleryDisplayMode } from './lib/asset-gallery-widget.model';

export const ASSET_GALLERY_WIDGET: WidgetInfo<AssetGalleryConfiguration> = {
  type: WidgetType.ASSET_GALLERY,
  defaultConfiguration: () => ({
    facets: [
      {
        name: 'PORTALS.FACETS.GENERAL',
        id: 'general',
        columns: [
          {
            facets: [
              {
                fieldId: 'file_format',
                facetType: 'SELECTION',
                behavior: 'EXPANDING',
                title: 'PORTALS.FACETS.FORMAT',
                facetId: 1
              }
            ]
          },
          {
            facets: [
              {
                fieldId: 'original_file_size',
                title: 'PORTALS.FACETS.SIZE',
                facetType: 'SELECTION',
                behavior: 'EXPANDING',
                facetId: 2
              }
            ]
          },
          {
            facets: [
              {
                fieldId: 'changedOn',
                title: 'PORTALS.ASSET_GALLERY_WIDGET.SORTER.MODIFICATION_DATE',
                facetType: 'DATE_CATEGORY',
                behavior: 'EXPANDING',
                facetId: 3
              }
            ]
          }
        ]
      }
    ],
    paginationMode: 'infinite-scroll',
    displayMode: AssetGalleryDisplayMode.CARD,
    lastFacetId: 3,
    librariesMode: 'filtered',
    libraryIds: [],
    style: {
      primary: { id: 'primary' },
      contrast: { id: 'contrast' }
    }
  }),
  thumb: 'widget-icon-gallery',
  name: 'EXPERIENCE.PORTAL_DESIGNER.WIDGET.ASSET_GALLERY_WIDGET.NAME',
  description: {},
  widgetComponent: () => import('./lib/asset-gallery-widget.component').then(module => module.AssetGalleryWidgetComponent)
};
